module.exports = __webpack_public_path__ + "assets/img/404.d86aec14.png";